import { Box } from "@mui/material";
import { Pagination, SuperChatContent } from "@/organism";
import { ChatContentDto } from "@/dto/ChatContentDto";
import useList from "./useList";

/**
 * QNA 컨텐츠 목록 템플릿 Props
 */
export type ListProps = {
  page: number;
  count: number;
  list: ChatContentDto[];
  isLoading?: boolean;
  filters: any;
  rowsPerPage?: number;
  onSearch: (filters: any) => void;
  onFilter: (filters: any) => void;
  onEdit: (contentId: number) => void;
  onPageChange?: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  onRowsPerPageChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
};

/**
 * QNA 컨텐츠 목록 템플릿
 *
 * @description 도장 목록 템플릿을 참고하여 구현
 * @param props ListProps
 * @returns JSX.Element
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export const List = (props: ListProps) => {
  const {
    page,
    count,
    list,
    isLoading,
    filters,
    rowsPerPage: propsRowsPerPage,
    onSearch,
    onFilter,
    onEdit,
    onPageChange,
    onRowsPerPageChange,
  } = props;

  const {
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
    contentRequest,
    handleSearchChange,
    handleResetFilters,
  } = useList({
    filters,
    onSearch,
    onFilter,
  });

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {/* 검색 및 필터 */}
      <SuperChatContent.Filter
        values={contentRequest}
        onChange={handleSearchChange}
        onReset={handleResetFilters}
      />

      {/* 컨텐츠 목록 */}
      <SuperChatContent.List
        list={list}
        isLoading={isLoading}
        onEdit={onEdit}
      />

      {/* 페이지네이션 */}
      {count > 0 && (
        <Pagination
          count={count}
          page={page - 1} // MUI Pagination은 0-based
          onPageChange={onPageChange || handlePageChange}
          onRowsPerPageChange={onRowsPerPageChange || handleRowsPerPageChange}
          rowsPerPage={propsRowsPerPage || rowsPerPage}
        />
      )}
    </Box>
  );
};
